import { Navigate } from "react-router-dom";

export default function ProtectedRoutes({ children, role, msalInstance }) {
  console.log(msalInstance);
  const activeAccount = msalInstance.getActiveAccount();
  const roles = activeAccount?.idTokenClaims?.roles || [];
  const isAdmin = roles.includes("LLMaaS_Admin");

  if (isAdmin) return children;
  return <Navigate to="/self-registration" />;
}
